var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"title":"Kredito davėjo kūrimas"}},[_c('v-btn',{attrs:{"color":"secondary","small":""},on:{"click":_vm.goToList}},[_vm._v("Grįžti į sąraša")])],1),(_vm.form)?_c('Form',{attrs:{"form":_vm.form}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }